module.exports = __webpack_public_path__ + "img/w3_bookmark_square_light.fcf152f1.png";